// extracted by mini-css-extract-plugin
module.exports = {"list":"tag-list_list__Ya9ZB"};